<template>
  <div class="member-card">
    <div class="member-card__title">
      Kartu Tanda Anggota
    </div>

    <div v-if="hasLoad" class="member-card__body">
      <div v-if="profile" class="member-card__content">
        <div class="kta-wrap">
          <div class="kta-card">
            <div class="kta-inner" id="cardMemberFront">
              <div class="kta-logo">
                <img
                  alt="logo"
                  src="../assets/images/newLogo-old-2.png"
                  class="logo"
                />
              </div>

              <div class="kta-band">
                <div class="kta-band__small">KARTU TANDA ANGGOTA</div>
                <div class="kta-band__big">PARTAI PERINDO</div>
              </div>

              <div class="kta-top">
                <div class="kta-body">
                  <div class="kta-no">{{ memberNoText }}</div>
                  <div class="kta-name">{{ fullNameText }}</div>

                  <div class="kta-row">{{ bornLineText }}</div>
                  <div class="kta-row">{{ addressLine1Text }}</div>
                  <div class="kta-row kta-phone" v-if="phoneText">Telp : {{ phoneText }}</div>
                </div>
                <canvas
                  ref="qrCanvas"
                  class="kta-qr"
                ></canvas>
              </div>

              <div class="kta-body kta-cta-area">
                <div class="kta-cta-wrap" ref="ctaWrap">
                  <button
                    class="kta-cta"
                    type="button"
                    @click="toggleDownloadMenu"
                    aria-haspopup="menu"
                    :aria-expanded="showDownloadMenu ? 'true' : 'false'"
                  >
                    <img src="../assets/icons/download.svg" class="kta-cta-icon kta-cta-icon--left" alt="">
                    Download KTA
                    <img
                      src="../assets/icons/down.svg"
                      class="kta-cta-icon kta-cta-icon--right"
                      :class="{ 'rotate-180': showDownloadMenu }"
                      alt=""
                    >
                  </button>

                  <div v-if="showDownloadMenu" class="kta-dropdown" role="menu">
                    <button
                      type="button"
                      class="kta-dropdown__item"
                      role="menuitem"
                      @click="onDownload('image')"
                    >
                      Download sebagai Gambar
                    </button>
                    <button
                      type="button"
                      class="kta-dropdown__item"
                      role="menuitem"
                      @click="onDownload('pdf')"
                    >
                      Download sebagai PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="member-card__placeholder">
        <slot name="placeholder">
          <NewCardPh />
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import NewCardPh from './NewCardPlaceholder.vue'
import domtoimage from 'dom-to-image-more'
import QRCode from 'qrcode'

export default {
  name: 'MemberCard',
  components: { NewCardPh },

  props: {
    hasLoad: { type: Boolean, default: false },
    profile: { type: Object, default: null },
    profilePic: { type: String, default: '' },
    photoPlaceholder: {
      type: [String, Object],
      default () {
        return require('../assets/images/photo_ph.svg')
      }
    },
    backCardImage: {
      type: [String, Object],
      default () {
        return require('../assets/images/kta-back-card-2025.jpg')
      }
    }
  },

  data () {
    return {
      showDownloadMenu: false,
      showDownload: false,
      isDownloading: false,
      download_count: 0
    }
  },

  computed: {
    qrValueText () {
      return this.profile?.member_no || ''
    },

    photoSrc () {
      return this.profilePic || this.photoPlaceholder
    },

    memberNoText () {
      return this.profile?.member_no || '-'
    },

    fullNameText () {
      return this.profile?.nama_lengkap || '-'
    },

    bornLineText () {
      const place =
        this.profile?.tempat_lahir ||
        this.profile?.kota_lahir ||
        this.profile?.place_of_birth ||
        ''

      const dobRaw =
        this.profile?.tanggal_lahir ||
        this.profile?.tgl_lahir ||
        this.profile?.date_of_birth ||
        ''

      const dob = this.formatDateDDMMYYYY(dobRaw)
      const left = place || '-'
      const right = dob || '-'
      return `${left} / ${right}`
    },

    addressLine1Text () {
      return this.profile?.alamat + `, ${this.profile?.post_code}`
    },

    phoneText () {
      return (
        this.profile?.no_hp ||
        this.profile?.phone ||
        this.profile?.phone_number ||
        ''
      )
    }
  },

  watch: {
    qrValueText (val) {
      if (!val) return
      this.$nextTick(() => this.renderQrCode())
    },
    showDownloadMenu (val) {
      if (val) {
        document.addEventListener('click', this.onOutsideClick)
        document.addEventListener('keydown', this.onKeydown)
      } else {
        document.removeEventListener('click', this.onOutsideClick)
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },

  beforeUnmount () {
    document.removeEventListener('click', this.onOutsideClick)
    document.removeEventListener('keydown', this.onKeydown)
  },

  updated () {
    this.tryRenderQr()
  },

  methods: {
    tryRenderQr () {
      if (this._qrRendered === this.qrValueText) return
      this.$nextTick(() => {
        if (this.$refs.qrCanvas && this.qrValueText) {
          this.renderQrCode()
          this._qrRendered = this.qrValueText
        }
      })
    },
    async renderQrCode () {
      const canvas = this.$refs.qrCanvas

      console.log({ canvas })

      if (!canvas || !this.qrValueText) return

      try {
        await QRCode.toCanvas(canvas, this.qrValueText, {
          width: 112,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        })
      } catch (err) {
        console.error('Gagal generate QR code:', err)
      }
    },
    toggleDownloadMenu () {
      this.showDownloadMenu = !this.showDownloadMenu
    },

    closeDownloadMenu () {
      this.showDownloadMenu = false
    },

    onOutsideClick (e) {
      const el = this.$refs.ctaWrap
      if (!el) return
      if (!el.contains(e.target)) this.closeDownloadMenu()
    },

    onKeydown (e) {
      if (e.key === 'Escape') this.closeDownloadMenu()
    },

    onDownload (type) {
      if (type === 'image') this.directDownload('image')
      if (type === 'pdf') this.directDownload('pdf')
      this.closeDownloadMenu()
    },

    formatDateDDMMYYYY (value) {
      if (!value) return ''
      const d = new Date(value)
      if (Number.isNaN(d.getTime())) return ''

      const dd = String(d.getDate()).padStart(2, '0')
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const yyyy = d.getFullYear()
      return `${dd}-${mm}-${yyyy}`
    },

    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    async directDownload (type = 'image') {
      // type: 'image' | 'pdf'
      this.showDownload = true
      await this.$nextTick()
      await this.sleep(200)

      try {
        if (type === 'pdf') await this.downloadCardPdf()
        else await this.downloadCardImage()
      } finally {
        this.showDownload = false
      }
    },

    async captureFrontPng () {
      const el = document.getElementById('cardMemberFront')
      if (!el) throw new Error('Element #cardMemberFront tidak ditemukan')

      this.isDownloading = true
      el.classList.add('to-download')
      await this.$nextTick()
      await this.sleep(250)

      const scale = 3

      const dataUrl = await domtoimage.toPng(el, {
        quality: 1,
        cacheBust: true,
        width: el.clientWidth * scale,
        height: el.clientHeight * scale,
        style: {
          transform: 'scale(' + scale + ')',
          transformOrigin: 'top left',
          opacity: 1
        }
      })

      el.classList.remove('to-download')
      return { dataUrl, width: el.clientWidth * scale, height: el.clientHeight * scale }
    },

    async loadImageAsDataUrl (src) {
      const url = typeof src === 'string' ? src : (src?.default || src)
      const res = await fetch(url, { cache: 'no-store' })
      const blob = await res.blob()

      return await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },

    async getBackPng () {
      const dataUrl = await this.loadImageAsDataUrl(this.backCardImage)
      return dataUrl
    },

    async mergeFrontBackToOneImage (frontDataUrl, backDataUrl, frontW, frontH) {
      const [frontImg, backImg] = await Promise.all([
        this.dataUrlToImage(frontDataUrl),
        this.dataUrlToImage(backDataUrl)
      ])

      const gap = 80

      // hitung tinggi berdasarkan rasio gambar (scaled to width frontW)
      const frontScale = frontW / frontImg.width
      const backScale = frontW / backImg.width

      const frontDrawH = Math.round(frontImg.height * frontScale)
      const backDrawH = Math.round(backImg.height * backScale)

      // canvas final mengikuti konten asli (bukan frontH*2)
      const canvas = document.createElement('canvas')
      canvas.width = frontW
      canvas.height = frontDrawH + gap + backDrawH

      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // gambar front: tidak perlu contain ke frontH, cukup pas-kan ke ukuran hasil scale
      ctx.drawImage(frontImg, 0, 0, frontW, frontDrawH)

      const backY = frontDrawH + gap
      ctx.drawImage(backImg, 0, backY, frontW, backDrawH)

      // garis batas
      ctx.strokeStyle = '#d6dbe7'
      ctx.lineWidth = 2
      ctx.beginPath()
      ctx.moveTo(0, frontDrawH - 1)
      ctx.lineTo(frontW, frontDrawH - 1)
      ctx.stroke()

      ctx.beginPath()
      ctx.moveTo(0, backY + 1)
      ctx.lineTo(frontW, backY + 1)
      ctx.stroke()

      // cropped ini harusnya gpp ga dipakai lagi
      const cropped = this.cropCanvas(canvas, { top: 0, bottom: 0 })

      return {
        dataUrl: cropped.toDataURL('image/jpeg', 0.95),
        width: cropped.width,
        height: cropped.height
      }
    },

    cropCanvas (canvas, { top = 0, right = 0, bottom = 0, left = 0 } = {}) {
      const out = document.createElement('canvas')

      const width = Math.max(1, canvas.width - left - right)
      const height = Math.max(1, canvas.height - top - bottom)

      out.width = width
      out.height = height

      const octx = out.getContext('2d')

      octx.drawImage(
        canvas,
        left, top,
        width, height,
        0, 0,
        width, height
      )

      return out
    },

    dataUrlToImage (dataUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = dataUrl
      })
    },

    async downloadCardImage () {
      try {
        const { dataUrl: frontUrl, width, height } = await this.captureFrontPng()
        const backUrl = await this.getBackPng()

        const { dataUrl: merged } = await this.mergeFrontBackToOneImage(frontUrl, backUrl, width, height)

        const link = document.createElement('a')
        link.download = `kartu-anggota-${(this.profile?.nama_lengkap || 'anggota')}.jpg`
        link.href = merged
        link.click()

        this.download_count += 1
      } catch (err) {
        console.error(err)
      } finally {
        this.isDownloading = false
      }
    },

    async downloadCardPdf () {
      try {
        const { dataUrl: frontUrl, width: frontW, height: frontH } = await this.captureFrontPng()
        const backUrl = await this.getBackPng()

        const merged = await this.mergeFrontBackToOneImage(frontUrl, backUrl, frontW, frontH)

        const { jsPDF: JsPDF } = await import('jspdf')

        const pdf = new JsPDF({
          orientation: merged.width >= merged.height ? 'landscape' : 'portrait',
          unit: 'px',
          format: [merged.width, merged.height]
          // hotfixes: ['px_scaling'],
        })

        pdf.addImage(
          merged.dataUrl,
          'JPEG',
          0,
          0,
          merged.width,
          merged.height,
          undefined,
          'FAST'
        )

        const safeName = (this.profile?.nama_lengkap || 'anggota').toString().replace(/[\\/:*?"<>|]/g, '-')
        pdf.save(`kartu-anggota-${safeName}.pdf`)

        this.download_count += 1
      } catch (err) {
        console.error(err)
      } finally {
        this.isDownloading = false
      }
    }

  }
}
</script>

<style scoped>
.member-card {
  width: 100%;
  background: #fff;
  border-radius: 16px;
  padding: 14px;
  height: 100%;
}

.member-card__title {
  font-weight: 800;
  color: #374151;
  font-size: 16px;
  margin-bottom: 14px;
}

.member-card__body {
  width: 100%;
}

.member-card__content {
  padding: 0;
}

.member-card__placeholder {
  height: 100%;
}

.kta-wrap {
  position: relative;
}

.kta-card {
  width: 100%;
  position: relative;
}

.kta-inner {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  overflow: visible;
}

.kta-logo {
  display: flex;
  justify-content: center;
  margin-top: 12px !important;
  margin-bottom: 4px !important;
}

.kta-band {
  padding: 10px 12px;
  text-align: center;
  color: #fff;
  background: linear-gradient(90deg, #1e3a8a 0%, #8b1d3a 100%);
}

.kta-band__small {
  font-size: 10px;
  letter-spacing: 1.8px;
  font-weight: 800;
  opacity: 0.9;
}

.kta-band__big {
  font-size: 22px;
  font-weight: 900;
  line-height: 1;
}

.kta-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.kta-qr {
  width: 112px;
  margin-right: 30px;
  margin-top: 10px;
  flex-shrink: 0;
}

/* body */
.kta-body {
  padding: 10px 18px 18px;
}

.kta-no {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 2px;
}

.kta-name {
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 6px;
  line-height: 1.1;
}

.kta-row {
  font-size: 12px;
  font-weight: 400;
  color: #111827;
  line-height: 1.3;
  margin-top: 2px;
}

.kta-phone {
  margin-top: 10px !important;
}

/* CTA AREA */
.kta-cta-area {
  margin-top: -32px;
}

/* button */
.kta-cta {
  width: 100%;
  border: none;
  border-radius: 8px;
  margin-top: 16px;
  padding: 14px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  background: #243b7a;
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;

  transition: transform 0.06s ease, filter 0.15s ease;
}

.kta-cta:active {
  transform: translateY(1px);
}

.kta-cta:hover {
  filter: brightness(1.05);
}

.kta-cta-icon {
  width: 18px;
  height: 18px;
  display: inline-block;
}

.kta-cta-icon--left {
  margin-right: 8px;
}

.kta-cta-icon--right {
  margin-left: 8px;
}

/* dropdown wrap */
.kta-cta-wrap {
  position: relative;
  width: 100%;
}

.kta-dropdown {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 8px);
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.14);
  overflow: hidden;
  z-index: 20;
}

.kta-dropdown__item {
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  cursor: pointer;
}

.kta-dropdown__item:hover {
  background: #f3f4f6;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.18s ease;
}

.logo {
  width: 76px;
}

@font-face {
  font-family: "Poppins";
  src: url("../assets/fonts/Poppins-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Poppins";
  src: url("../assets/fonts/Poppins-SemiBold.ttf") format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Poppins";
  src: url("../assets/fonts/Poppins-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Poppins";
  src: url("../assets/fonts/Poppins-ExtraBold.ttf") format("truetype");
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Poppins";
  src: url("../assets/fonts/Poppins-Black.ttf") format("truetype");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

@media only screen and (max-width: 600px) {
  .kta-band__big {
    font-size: 14px;
  }

  .kta-name {
    font-size: 14px;
  }

  .kta-cta {
    font-size: 16px;
  }

  .kta-qr {
    margin-right: 12px;
    width: 110px;
  }

  .kta-row {
    font-size: 8px;
  }

  .kta-no {
    font-size: 11px;
  }

  .kta-qr {
    width: 84px;
  }

  .kta-band__small {
    font-size: 8px;
  }
}

.to-download {
  opacity: 1 !important;
  filter: none !important;
}

.to-download .kta-cta-area {
  display: none !important;
}

.kta-inner.to-download {
  border-radius: 0 !important;
  border: 0;
  overflow: visible !important;
}

#cardMemberFront.to-download .kta-qr {
  width: 100px !important;
  margin-bottom: 18px !important;
  margin-top: 22px !important;
  margin-right: 24px !important;
}
#cardMemberFront.to-download .kta-phone {
  margin-top: 4px !important;
  font-weight: 500 !important;
  margin-bottom: 18px !important;
}
#cardMemberFront.to-download .kta-row {
  font-size: 12px !important;
  font-weight: 500 !important;
}
#cardMemberFront.to-download .kta-no {
  font-size: 17px !important;
}
#cardMemberFront.to-download .kta-name {
  font-size: 22px !important;
}
#cardMemberFront.to-download .kta-band__small {
  font-size: 11px !important;
}
#cardMemberFront.to-download .kta-band__big {
  font-size: 23px !important;
}

#cardMemberFront.to-download {
  font-family: "Poppins", sans-serif !important;
}

#cardMemberFront.to-download * {
  font-family: "Poppins", sans-serif !important;
}
</style>
